export { default } from './AutoCompleteTextInputStateful';
